import { ClockIcon } from "@heroicons/react/24/outline"

import { StockIndicator } from "../StockIndicator"

export type VariantInventoryItem = {
  /**
   * Title (i.e., `display_name`) of the variant.
   */
  title: string
  /**
   * HREF to the order history of this variant.
   */
  historyHref?: string
  /**
   * Amount of items in stock. Optional if the item is always available (i.e. when inventoryRequired is false).
   */
  quantity?: number
  /**
   * Whether or not the item is always in stock (i.e., not required).
   */
  inventoryRequired: boolean
  /**
   * Amount of items on waitlist.
   */
  waitlistQuantity?: number
}

export type VariantInventoryTableProps = {
  /**
   * List of variant items.
   */
  items: VariantInventoryItem[]
}

export function VariantInventoryTable(props: VariantInventoryTableProps) {
  const { items } = props
  const anyOnWaitlist = items.some((item) => item.waitlistQuantity)
  const anyStock = items.some((item) => item.inventoryRequired)

  return (
    <div className="@container w-full border-t border-t-gray-200">
      <table className="w-inherit">
        <tbody>
          {items.map((item) => {
            const { title, historyHref, waitlistQuantity, inventoryRequired } = item
            const quantity = inventoryRequired ? item.quantity : Infinity

            return (
              <tr
                key={title}
                className="flex flex-col border-b border-b-gray-200 py-2 text-sm text-gray-500 @sm:table-row @sm:py-0 @sm:[&>td]:py-2"
              >
                <td>{title}</td>

                <td className="order-11 @sm:px-2 @sm:[&:last-child>div]:justify-end">
                  <a className="underline" href={historyHref}>
                    Order History
                  </a>
                </td>
                {anyOnWaitlist ? (
                  <td className="order-12">
                    {waitlistQuantity && (
                      <span className="flex items-center gap-1">
                        <ClockIcon className="inline h-4 w-4 text-sky-500" />
                        <strong className="font-medium">{waitlistQuantity} on waitlist</strong>
                      </span>
                    )}
                  </td>
                ) : (
                  <></>
                )}

                {anyStock && (
                  <td className="w-0">
                    <div className="flex items-end">
                      {quantity == null ? <></> : <StockIndicator className="ml-auto" hideDot quantity={quantity} />}
                    </div>
                  </td>
                )}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
